var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ubc-id"},[_c('masked-input',{class:_vm.maskedInputClass,attrs:{"id":_vm.id,"mask":"U-####-####","placeholder":"U-0000-0000","masked":""},nativeOn:{"keyup":function($event){return _vm.enterPressed.apply(null, arguments)}},model:{value:(_vm.ubcId),callback:function ($$v) {_vm.ubcId=$$v},expression:"ubcId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }